module.exports = __webpack_public_path__ + "static/media/hare-foot.99fe3aca.png";